export const TID = {
  // Nav
  navLogo: "nav-logo",
  navHome: "nav-home",
  navNewAnalysis: "nav-new-analysis",
  navRecent: "nav-recent",

  // Landing
  landingHero: "landing-hero",
  landingCta: "landing-cta-start",
  landingCtaSecondary: "landing-cta-learn",

  // New analysis
  uploadDropzone: "upload-dropzone",
  uploadFileInput: "upload-file-input",
  uploadFilename: "upload-filename",
  pasteTab: "tab-paste",
  uploadTab: "tab-upload",
  pasteTextarea: "paste-textarea",
  extractedPreview: "extracted-preview",
  nextStepBtn: "next-step-btn",
  prevStepBtn: "prev-step-btn",
  submitAnalysisBtn: "submit-analysis-btn",

  // Profile fields
  field: (name) => `profile-field-${name}`,

  // Report
  reportContainer: "report-container",
  reportTitle: "report-title",
  reportOpportunityScore: "score-opportunity",
  reportMatchScore: "score-match",
  reportWinProbability: "win-probability",
  reportFinalVerdict: "final-verdict",
  reportPursuit: "pursuit-recommendation",
  reportSection: (key) => `report-section-${key}`,
  reportTocItem: (key) => `toc-${key}`,
  exportPdfBtn: "export-pdf-btn",
  copyShareBtn: "copy-share-btn",

  // Recent
  recentItem: (id) => `recent-${id}`,
};
